import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { GoalEvent } from './goal.event';

@Injectable()
export class GoalEventProvider extends DomainEventProvider<GoalEvent> {}
